import { styled, Icon } from '@mui/material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import React from 'react';

const Container = styled('div')(({ theme }) => ({
    '.arrow-text': {
        fontSize: 14,
        fontWeight: 600,
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        color: theme.vars.palette.text.primary,
        margin: `5px 0`,
        ':hover': {
            cursor: 'pointer',
        },
    },
}));
const IconComponent = (React.createElement(Icon, { sx: (theme) => ({ color: theme.vars.palette.primary.main }) },
    React.createElement(ArrowRightAltIcon, null)));
const ArrowLink = ({ text, url, Link, onTextClick }) => {
    const handleClick = () => {
        if (onTextClick)
            onTextClick();
    };
    return (React.createElement(Container, null, Link && url ? (React.createElement(Link, { to: url, style: { textDecoration: 'none' }, className: "arrow-text" },
        text,
        IconComponent)) : (React.createElement("div", { onClick: handleClick, className: "arrow-text" },
        text,
        IconComponent))));
};

export { ArrowLink };
//# sourceMappingURL=ArrowLink.js.map
